import { html } from 'lit';

export const iconAngleUp = html`
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 6.375C10.3789 6.375 10.1602 6.29297 9.99609 6.12891L6.25 2.38281L2.47656 6.12891C2.14844 6.48438 1.57422 6.48438 1.24609 6.12891C0.890625 5.80078 0.890625 5.22656 1.24609 4.89844L5.62109 0.523438C5.94922 0.167969 6.52344 0.167969 6.85156 0.523438L11.2266 4.89844C11.582 5.22656 11.582 5.80078 11.2266 6.12891C11.0625 6.29297 10.8438 6.375 10.625 6.375Z"
      fill="currentColor"
    />
  </svg>
`;
